if (typeof window !== 'undefined' && window && window.config) {
  module.exports = window.config;
} else if (
  typeof process !== 'undefined' &&
  typeof process.env !== 'undefined' &&
  typeof process.env.config !== 'undefined') {
  module.exports = process.env.config;
} else {
  module.exports = {};
}